import { SocialService } from '../SocialService';
import { SocialFriendsList } from './Temp/SocialFriendsList';
import { SocialButton } from './Temp/SocialButton';
import { Inject } from '@denishussar/html5-game-engine';
import { FirebaseCloudDB } from '../../../Services/CloudDB/FirebaseCloudDB';

/*declare global {
    interface Window {
        API_callback: (method, result, data) => void;
    }
}*/

interface IUserData {
    api_server: string,
    apiconnection: string,
    application_key: string,
    auth_sig: string,
    authorized: number,
    clientLog: number,
    container: boolean,
    first_start: number,
    ip_geo_location: string,
    logged_user_id: number,
    new_sig: number
    session_key: string,
    session_secret_key: string,
    sig: string,
    user_gender: number,
    user_image: string,
    user_name: string,
    web_server: string
}

export class OkUI extends PIXI.Container {

    private GROUP_ID = 123;//511126998363;
    private GAME_LINK = 'https://vk.com/app7979319_676657198';

    private userData: IUserData;

    private _cont = new PIXI.Container();
    private _friendList = new SocialFriendsList();

    constructor(@Inject private service: SocialService,
                @Inject private db: FirebaseCloudDB) {
        super();
        this.init();
    }

    private async init() {
        this.addChild(this._cont);
        this._cont.visible = false;

        console.log('OKUI init')
        this.userData = await this.service.initApp()
            .catch((error) => {
                console.log('OkUI.init() error')
            });

        if (this.userData === undefined) {
            return Promise.reject();
        }
        console.log('this.userData', this.userData);
        const dbAuthToken = await this.service.getToken().catch(console.error);
        if (typeof dbAuthToken === 'string') {
            console.log(dbAuthToken);
            this.db.authWithToken(dbAuthToken);
        } else console.error('bad token', dbAuthToken);
        /*
                // @ts-ignore
                window.API_callback = (method, result, data) => {
                    // обработка ответов от методов ОК
                    console.log('[CALL BACK]:::', method, result);
                }*/
        this.generatePage();
    }

    private async generatePage() {
        //--------------------
        const avatar = PIXI.Sprite.from(this.userData.user_image);
        avatar.width = 100;
        avatar.height = 100;
        avatar.buttonMode = true;
        avatar.interactive = true;
        avatar.on('pointerdown', this.onClickSocial.bind(this));
        this.addChild(avatar);

        const back = new PIXI.Graphics();
        back.beginFill(0x000000, 0.7);
        back.drawRect(0, 0, 800, 500);
        this._cont.addChild(back);
        const fio = new PIXI.Text(
            `${this.userData.user_name}, ID: ${this.userData.logged_user_id}`,
            {
                fill: 0xffffff,
                fontSize: 30,
                fontWeight: 'bold'
        });

        fio.x = 110;
        fio.y = 50 - fio.height / 2;
        this._cont.addChild(fio);
        //--------------------

        const btnPost = new SocialButton('Пост', 0xff0000);
        btnPost.on('pointerdown', () => {
            this.service.postMessage("Привет, классная игра!", '')
            //this.postMessage("Привет, классная игра!", this.GAME_LINK);
        });
        btnPost.x = back.width / 2 - btnPost.width / 2;
        btnPost.y = 100;
        this._cont.addChild(btnPost);

        const btnGetFriends = new SocialButton('Друзья', 0xff0000);
        btnGetFriends.on('pointerdown', async () => {
            const friendsList = await this.service.getFriends(
                // (data) => {
                //     console.log(data, '++++++++++++')
                //     this.generateFriendList(data)
                // }
            );

        });
        btnGetFriends.x = btnPost.x;
        btnGetFriends.y = btnPost.y + btnPost.height + 5;
        this._cont.addChild(btnGetFriends);

        const btnPermissionNotification = new SocialButton('Уведомления', 0xff0000);
        btnPermissionNotification.on('pointerdown', async () => {
            try {
                // @ts-ignore
                const notification = await this.service.showNotification();
                console.log(notification);
            } catch (e) {
                console.log('NOTIFICATION FAIL!!!', e);
            }
        });
        btnPermissionNotification.x = btnGetFriends.x;
        btnPermissionNotification.y = btnGetFriends.y + btnGetFriends.height + 5;
        this._cont.addChild(btnPermissionNotification);

        const btnInvite = new SocialButton('Пригласить', 0xff0000);
        btnInvite.on('pointerdown', async () => {
            // this.service.showInvite("Привет, давай поиграем!", '', []);
            this.service.showInvite();
        });
        btnInvite.x = btnPermissionNotification.x;
        btnInvite.y = btnPermissionNotification.y + btnPermissionNotification.height + 5;
        this._cont.addChild(btnInvite);

        const addGroup = new SocialButton('В сообщество', 0xff0000);
        addGroup.on('pointerdown', async () => {
            this.service.joinGroup();
        })
        addGroup.x = btnInvite.x;
        addGroup.y = btnInvite.y + btnInvite.height + 5;
        this._cont.addChild(addGroup);


        this.addChild(this._friendList);
    }

    /*private async appInit() {
        // @ts-ignore
        const data = await FAPI.Util.getRequestParameters();
        // @ts-ignore
        await FAPI.init(
            data.api_server,
            data.apiconnection,
            () => {console.log('OK API Init');},
            () => {console.log('OK API Init Fail');}
        );
        return data;
    }

    private async postMessage(message: string, attachments: string) {
        // @ts-ignore
        const data = await FAPI.UI.postMediatopic(
            {
                "media":[
                    {
                        "type": "text",
                        "text": message
                    },
                    {
                        "type": "link",
                        "url": this.GAME_LINK
                    }
                ]
            },
            false,
        );

   }

  /* private async getFriends() {
       // @ts-ignore
       const friends = await FAPI.Client.call({"method":"friends.get"}, this.callbackCurrentUserFriends.bind(this));
   }

   private callbackCurrentUserFriends(status, data, error) {
    if (data) {
        // @ts-ignore
        FAPI.Client.call(
            {
                "method":"users.getInfo",
                "fields":"first_name,last_name,pic128x128",
                "uids":data
            },
                this.callbackFriendsInfo.bind(this)
        );
    } else {
        console.log(error);
    }
   }
   private callbackFriendsInfo(status, data, error) {
        this.generateFriendList(data);
   }*/

    /*private async showNotification() {
        // @ts-ignore
        const notification = await FAPI.UI.showNotification("Поиграй в мою игру!", "arg1=val1");
        return notification;
    }

    private async showInvite(text: string, params: string, selectedIds:[]) {
        // @ts-ignore
        const invite = await FAPI.UI.showInvite(text, params, selectedIds);
        return invite;
    }

    private async joinToGroup() {
        // @ts-ignore
        const join = await FAPI.invokeUIMethod("joinGroup", this.GROUP_ID);
    }

    private async addToBookMark() {
        // @ts-ignore
        FAPI.Client.call(
         {
             "method":"bookmark.add",
             "ref_id": 512001010082,
             "bookmark_type":'products',
         },
             (status, data, error) => {
                 console.log(status, data, error)
             }
         );
    }*/

   //temp
   private generateFriendList(data:[]) {
        const ar:{id: string, photo_100: string}[] = [];
        for (let i = 0; i < data.length; i++) {
            ar.push({id: data[i]['uid'], photo_100: data[i]['pic128x128']});
        }
        // @ts-ignore
        this._friendList.init(ar)
   }

    private onClickSocial() {
        this._cont.visible = !this._cont.visible;
    }
}